import * as React from 'react';
import { Responsive, uaToDeviceType, UiKitRoot } from '@cian/ui-kit';
import { DesktopViewContainer, MobileViewContainer } from '../Views';

export interface IPageContainerProps {
  userAgent: string | null;
}

export const PageContainer: React.FC<IPageContainerProps> = ({ userAgent }) => {
  const deviceType = React.useMemo(() => uaToDeviceType(userAgent || undefined), [userAgent]);

  return (
    <UiKitRoot deviceType={deviceType}>
      <Responsive phone tablet>
        <MobileViewContainer />
      </Responsive>
      <Responsive desktop>
        <DesktopViewContainer />
      </Responsive>
    </UiKitRoot>
  );
};
